import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useSaleCalendar } from '../SaleCalendarContext';
import BlockModal from '../modals/BlockModal';
import SlotsControlModal from '../modals/SlotsControlModal';

export const DayContextMenu = () => {
  const { contextMenu, closeContextMenu, periods, setSlotControlByDay,
    setBlockedResourceDates, setTransitionDayEvents,
    submitSaleCalendar } = useSaleCalendar();
  const [openBlockModal, setOpenBlockModal] = React.useState(false);
  const [openSingleSlotControlModal, setOpenSingleSlotControlModal] = React.useState(false);

  const handleClose = () => {
    setOpenBlockModal(false);
    closeContextMenu();
  };

  const blockWholeDay = (unlock = false, reason = '') => {
    const eventObjects = [];
    periods.map(p => eventObjects.push(
      {
        start: contextMenu.date,
        end: contextMenu.date,
        display: 'background',
        color: 'rgba(101, 67, 33, 0.5)',
        resourceId: p.id,
        id: contextMenu.date + contextMenu.date + p.id,
        title: reason
      }
    ));
    setBlockedResourceDates(prev => {
      if (unlock) {
        const eventIds = eventObjects.map(eo => eo.id);

        return [...prev.filter(p => !eventIds.includes(p.id))];
      }
      const prevIds = prev.map(p => p.id);
      const filteredEventObjects = eventObjects.filter(eo => !prevIds.includes(eo.id));

      return [...prev, ...filteredEventObjects];
    });
    handleClose();
  };

  const handleSetTransitionDays = () => {
    const dateStr = contextMenu.date;

    setTransitionDayEvents(prev => {
      const existingIds = new Set(prev.map(item => item.id));
      const newItems = [];

      for (const period of periods.filter(p => [
        '3 DNI - MUNDUROWA',
        '3 DNI GIEWARTÓW',
        '3 DNI MRÓWKI',
        '3 DNI',
        'WEEKEND',
        'WEEKEND GIEWARTÓW',
        'WEEKEND MRÓWKI',
        '5 DNI - MUNDUROWA',
        '5 DNI GIEWARTÓW',
        '5 DNI MRÓWKI',
        '5 DNI'
      ].includes(p.title))) {
        const eventId = `${dateStr}-${period.id}`;
        if (!existingIds.has(eventId)) {
          newItems.push({
            start: dateStr,
            end: dateStr,
            display: 'background',
            color: 'transparent',
            id: eventId,
            resourceId: period.id,
            type: 'transitionDay',
            classNames: ['transition-day-zebra']
          });
        }
      }

      return [...prev, ...newItems];
    });
    handleClose();
  };

  const handleUnSetTransitionDays = () => {
    const dateStr = contextMenu.date;

    setTransitionDayEvents(prev => prev.filter(event => !(event.type === 'transitionDay' && event.start === dateStr)
    )
    );
  };

  return (
    <>
      <Menu
        open={contextMenu?.visible && Boolean(contextMenu.x) && Boolean(contextMenu.y)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu?.y && contextMenu?.x
            ? { top: contextMenu.y, left: contextMenu.x }
            : undefined
        }
        disableAutoFocusItem
      >
        <MenuItem onMouseDown={() => {
          setOpenBlockModal(true);
        }}>
        Zablokuj ten dzień dla wszystkich terminów
        </MenuItem>
        <MenuItem onMouseDown={() => blockWholeDay(true)}>
        Odblokuj ten dzień dla wszystkich terminów
        </MenuItem>
        <MenuItem onMouseDown={handleSetTransitionDays}>
        Ustaw jako dzień przejściowy
        </MenuItem>
        <MenuItem onMouseDown={handleUnSetTransitionDays}>
        Odznacz jako dzień przejściowy
        </MenuItem>
        <MenuItem onMouseDown={() => setOpenSingleSlotControlModal(true)}>
        Ustaw ilość miejsc...
        </MenuItem>
      </Menu>
      <BlockModal
        open={openBlockModal}
        blockFunction={blockWholeDay}
        handleClose={() => setOpenBlockModal(false)}
      />
      <SlotsControlModal
        open={openSingleSlotControlModal}
        handleClose={() => setOpenSingleSlotControlModal(false)}
        targetDate={contextMenu.date}
      />
    </>
  );
};
